/** @format */

import styled from 'styled-components';

export const Navigation = styled.div`
  width: 100%;
  z-index: 99;
  position: relative;
  background-color: ${props => props.theme.colors.joivy.white};
  border-bottom: 1px solid ${props => props.theme.colors.alternativeGrey};

  .page-container {
    position: relative;
    padding-inline: 10px;
    width: 100%;
    max-width: 1098px;
    margin: 0 auto;
  }

  @media screen and (max-width: ${props => props.theme.breakpoints.xs}) {
    & header {
      height: auto;
    }
  }

  .room-page-header-transparent {
    background-color: transparent !important;
    transition: none;

    &::before {
      background-color: transparent !important;
      transition: 0.3s ease-in-out background-color;
      padding: 0 !important;
    }

    @media screen and (max-width: ${props => props.theme.breakpoints.lg}) {
      background-color: transparent !important;
      transition: none;

      &::before {
        background-color: transparent !important;
      }

      > div,
      ul {
        opacity: 1;
        visibility: visible;
        transition: 0.3s ease-in-out all;
      }
    }
  }

  .room-page-header {
    @media screen and (max-width: ${props => props.theme.breakpoints.lg}) {
      transition: 0.3s ease-in-out all;
      background-color: transparent !important;

      &::before {
        background-color: transparent !important;
        transition: 0.3s ease-in-out all;
        padding: 35px 0 0 0 !important;
      }

      > div,
      ul {
        transition: 0.3s ease-in-out all;
      }
    }
  }

  .room-page-header::before {
    position: absolute;
    content: '';
    top: -35px;
    left: 49%;
    transform: translateX(-50%);
    background: ${props => props.theme.colors.joivy.white};
    min-height: 100%;
    z-index: -1;
    width: 100vw;
    padding: 35px 0 0 0 !important;
  }
`;

export const Container = styled.div`
  position: relative;
  padding-inline: 10px;
  width: 100%;
  max-width: 1098px;
  margin: 0 auto;
  padding-top: 30px;
  padding-bottom: 135px;

  @media screen and (max-width: ${props => props.theme.breakpoints.xs}) {
    padding-top: 0;
  }
`;

export const RoomInfoTitle = styled.h1`
  color: ${props => props.theme.colors.joivy['teal-dark']};
  font-size: clamp(1.5rem, 1.3702rem + 0.5769vw, 2.0625rem);
  line-height: clamp(1.75rem, 1.6058rem + 0.641vw, 2.375rem);
  letter-spacing: clamp(0.03rem, 0.0274rem + 0.0115vw, 0.04125rem);
  margin-block: 1.25rem 0.75rem;
  text-wrap: balance;

  @media screen and (min-width: 767px) {
    margin-top: 0;
  }
`;

export const CustomTitle = styled.h2<{ $subtitle?: boolean }>`
  margin-block: ${({ $subtitle = false }) => ($subtitle ? '1.875rem 0.75rem' : '1.875rem')};
  color: ${({ theme }) => theme.colors.joivy['teal-dark']};
  font-size: clamp(1.125rem, 1.0417rem + 0.3704vw, 1.375rem);
  letter-spacing: clamp(0.0225rem, 0.0208rem + 0.0074vw, 0.0275rem);
  color: ${({ theme }) => theme.colors.joivy['teal-dark']};
`;

export const WrapperInfoPosition = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-block: 0 0.75rem;
  gap: 0.5rem;

  font-size: 0.9375rem;

  & > div {
    flex-wrap: wrap;
    img,
    a,
    p {
      margin-block: 0;
    }
  }

  span {
    color: ${({ theme }) => theme.colors.joivy.pink};
    margin-left: 0.25rem;
  }

  p {
    margin-block: 0;
  }

  a,
  button {
    background: transparent;
    border: none;
    outline: none;
    color: ${({ theme }) => theme.colors.joivy.black};
    text-decoration: underline;
    text-underline-offset: 3px;
    text-transform: capitalize;
    cursor: pointer;
    padding: 0;
    font: inherit;

    transition: all 0.3s ease-in-out;

    &:hover {
      color: ${({ theme }) => theme.colors.joivy['teal-dark']};
    }
  }
`;

export const RoomInformations = styled.div`
  @media screen and (max-width: 768px) {
    display: none;
  }
`;
